import { Aggregates } from "hfapi";

class ResumeQuestion extends Aggregates.ResumeQuestion {
}

export default ResumeQuestion;
